// TEMPORARY, single-binder feature (Jazz Neuroscience / bdr_0tp6w30Of7g).
//
// Hardcoded "Insight Type" tag options, rendered as multi-select pills below the
// Key Insight Topics selector. Gated by `taxonomy.insightTypesEnabled` (computed
// server-side in taxonomy_service from INSIGHT_TYPES_BINDER_IDS).
//
// To retire: delete this folder and its usages (see the exit strategy in the
// plan). To productionize: source these from binder config served via taxonomy.
export const INSIGHT_TYPES = [
  'Jazz Presentation',
  'Competitor Presentation',
  'Data Gaps',
  'Data Analysis Ideas',
  'Feedback on Data',
  'KOL Meeting',
  'Congress Buzz',
  'Presenter Feedback',
  'Others',
] as const
